import { useWheelStore } from './store';
import { ActionsCreatorParams } from './types';

export const wheelActionsCreator = ({ setState }: ActionsCreatorParams) => {
  return {
    SET_WHEEL_STATE: (payload: boolean) => {
      setState({ isModalOpened: payload });
    },
    SET_SPIN_TIME: (payload: Date | null) => {
      setState({ spinTime: payload });
    },
    SET_WINNER_SEGMENT: (payload: string) => {
      setState({ winnerId: payload });
    }
  };
};

export const wheelActions = wheelActionsCreator(useWheelStore);
